window.EmailAlertDialog = {
  alert_data: [],
  industries: [],
  edit_record: null,
  default_subject_line: '',
  init: function () {
    if (jQuery('#dlg_registration').length > 0) { return }
    jQuery('#lnk_email_registration').click(EmailAlertDialog.load_dialog_from_server)
  },
  setup_after_load: function () {
    if (jQuery('#email-alert-container').length == 0) { return }
    try {
      EmailAlert.setup_table()
    } catch (err) {

    }

    EmailAlertDialog.setup_alert_dialog()
    $('#email_wizard a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      e.target // newly activated tab
      e.relatedTarget // previous active tab
      jQuery('#filing_types').multiselect('reload')
    })

    EmailAlertDialog.setup_filer_autocomplete()
    EmailAlertDialog.setup_industry_dialog()
    jQuery('#lnk_remove_all').css('display', 'none')
    jQuery('#lnk_remove_all').click(EmailAlertDialog.remove_all_filers)
    jQuery('#rdo_predefined').change(EmailAlertDialog.on_radio_filer_change)
    jQuery('#rdo_individual_filer').change(EmailAlertDialog.on_radio_filer_change)
    jQuery('#rdo_industry').change(EmailAlertDialog.on_radio_filer_change)
    jQuery('#rdo_all_form_types').change(EmailAlertDialog.on_radio_form_types_change)
    jQuery('#rdo_individual_form_types').change(EmailAlertDialog.on_radio_form_types_change)
    jQuery('#cmd_uncheck_form_types').click(EmailAlertDialog.clear_form_types)
    jQuery('#cmd_check_form_types').click(EmailAlertDialog.select_all_form_types)
    jQuery('#lnk_show_advanced').click(EmailAlertDialog.toggle_advanced_settings)
    jQuery('#filing_types').multiselect({ columns: 4,
      texts: {
        placeholder: 'Select form types to include'
      },
      selectedList: 4,
      noneSelectedText: 'Select form types to include',
      minWidth: 400 })

    // if (jQuery('#lnk_email_registration').length > 0)
    //    jQuery("#lnk_email_registration").click(EmailAlertDialog.load_dialog_from_server);
    // if (typeof EmailAlert !== "undefined")
    // EmailAlert.setup_history_dialog();

    // jQuery('#cmd_add_alert').click(EmailAlertDialog.show_alert_dialog);
    /* }});
         loader.insert(); */
  },
  setup_filer_autocomplete: function () {
    jQuery('#txt_filer').autocomplete({
      source: '/email_alert/filer_lookup',
      minLength: 1,
      appendTo: '#ac_txt_filer',
      focus: function (event, ui) {
        jQuery('#txt_filer').val(ui.item.name)
        return false
      },
      select: function (event, ui) {
        EmailAlertDialog.add_filer_to_list({ name: ui.item.name, id: ui.item.id, permalink: ui.item.permalink })
        jQuery('#txt_filer').val('')

        return false
      }
    }).data('ui-autocomplete')._renderItem = function (ul, item) {
      val = item.name + ' (CIK: ' + item.cik + ')'
      val = '<div class="result"><span class="name">' + val + '</span></div>'
      return jQuery('<li class="lookup_autocomplete"></li>')
        .data('item.autocomplete', item)
        .append('<a>' + val + '</a>')
        .appendTo(ul)
    }
  },
  setup_industry_dialog: function () {
    /*  var handleCancel = function() {
         this.cancel();
         };     */
    var handleOk = function () {
      var selectedNodes = EmailAlertDialog.sector_tree.getNodesByProperty('highlightState', 1)
      if (!selectedNodes || selectedNodes.length == 0) {
        whalewisdom.Utilities.show_alert('Error', 'Please select an industry to receive alerts for.')
        return false
      }
      var record = selectedNodes[0].record
      var parent = null
      if (record.parent_id) {
        for (var i = 0; i < EmailAlertDialog.industries.length; i++) {
          if (EmailAlertDialog.industries[i].id == record.parent_id) {
            parent = EmailAlertDialog.industries[i]
            break
          }
        }
      }
      jQuery('#span_industry_selection').html(parent == null ? record.name : parent.name + ':' + record.name)
      jQuery('#hdn_industry').val(record.id)
      // EmailAlertDialog.industry_dialog.hide();
      jQuery('#industry_dialog').modal('hide')
    }
    jQuery('#industry_dialog').modal({ show: false })
    // jQuery('#cmd-industry-dialog-ok').click(handleOk);
    // Instantiate the Dialog
    /* EmailAlertDialog.industry_dialog = new YAHOO.widget.Dialog("industry_dialog",
         {width : "20em",
         fixedcenter : true,
         visible : false,
         modal:true,
         effect:{effect:YAHOO.widget.ContainerEffect.FADE,duration:0.15},
         constraintoviewport : true,
         buttons : [  {text:"Ok", handler:handleOk, isDefault:true},
         {text:"Cancel", handler:handleCancel, isDefault:true}]
         });

         // Render the Dialog
         EmailAlertDialog.industry_dialog.render();       */
    var b = jQuery('#toggle_industry_dialog')// new YAHOO.widget.Button("toggle_industry_dialog");
    var toggle = function (e) {
      var id = jQuery('#hdn_industry').val()
      if (id != '') {
        /* var nodes = EmailAlertDialog.sector_tree.selectedItems;
                if (nodes && nodes.length > 0) {
                    nodes[0].highlight();
                } */
        jQuery('#email_alert_sector_tree a').removeClass('whalewisdom-tree-highlighted')
        jQuery('#email_alert_sector_tree').find('a[data-id="' + id + '"]').addClass('whalewisdom-tree-highlighted')
      }
      // EmailAlertDialog.industry_dialog.show();
      jQuery('#industry_dialog').modal('show')
    }
    b.on('click', toggle)
    jQuery('.whalewisdom-tree-link').click(function (e) {
      var link = jQuery(this)
      var description = link.html()
      if (link.hasClass('industry-link')) { description = link.parent().parent().parent().find('.sector-link').html() + ':' + description }
      jQuery('#span_industry_selection').html(description)
      jQuery('#hdn_industry').val(link.attr('data-id'))
      jQuery('#industry_dialog').modal('hide')
    })
    //  EmailAlertDialog.sector_tree =  jQuery('#email_alert_sector_tree').tree({dataSource: treesource});

    /* EmailAlertDialog.sector_tree = new YAHOO.widget.TreeView("email_alert_sector_tree");
        EmailAlertDialog.populate_sector_tree();
        EmailAlertDialog.sector_tree.singleNodeHighlight = true;
        EmailAlertDialog.sector_tree.subscribe('clickEvent', EmailAlertDialog.sector_tree.onEventToggleHighlight);
        EmailAlertDialog.sector_tree.render(); */
  },
  build_sector_tree: function () {
    // sector arry record stock_count, total_mv, industry, sector
    // var tmpNode = new YAHOO.widget.TextNode("label-" + i, tree.getRoot(), false);
    // new YAHOO.widget.TextNode(node.label + "-" + i, node, false);
    var parent_node = null
    var child_node = null
    var record = null
    var child_record = null
    var data = []
    for (var i = 0; i < EmailAlertDialog.industries.length; i++) {
      record = EmailAlertDialog.industries[i]
      parent_node = new YAHOO.widget.TextNode(record.name.capitalize(), EmailAlertDialog.sector_tree.getRoot(), false)
      parent_node.record = record
      for (var j = 0; j < record.children.length; j++) {
        child_record = record.children[j]
        child_node = new YAHOO.widget.TextNode(
          child_record.name.capitalize(),
          parent_node, false)
        child_node.record = child_record
      }
    }
    return data
  },
  ac_filer_select_event: function (sType, aArgs) {
    var ac = aArgs[0]
    var li = aArgs[1]
    var data = aArgs[2]
    // add entry to filer_table and clear selection
    EmailAlertDialog.add_filer_to_list({ name: data[0], id: data[1], permalink: data[2] })
    jQuery('#txt_filer').val('')
  },
  add_filer_to_list: function (filer) {
    var list = jQuery('#selected_portfolios')[0]
    var exists = jQuery('#item_' + filer.id)
    if (exists.length > 0) { return }
    var item = document.createElement('span')
    var li_item = document.createElement('li')
    li_item.id = 'item_' + filer.id
    li_item.filer = filer
    var filer_lnk = document.createElement('a')
    filer_lnk.href = '/filer/' + filer.permalink
    if (filer.name.length > 27) { filer_lnk.innerHTML = filer.name.substr(0, 25) + '...' } else { filer_lnk.innerHTML = filer.name }
    var lnk = document.createElement('a')
    lnk.href = 'javascript:void(0);'
    lnk.className = 'remove_link'
    lnk.filer = filer
    jQuery(lnk).click(EmailAlertDialog.remove_filer_link_clicked)
    lnk.innerHTML = '(remove)'
    item.appendChild(filer_lnk)
    item.appendChild(lnk)

    li_item.appendChild(item)
    var hdn = document.createElement('input')
    hdn.type = 'hidden'
    hdn.name = 'email_alert[email_notification_filers_attributes][][filer_id]'
    hdn.value = filer.id
    /* var hdn = new Element('input', {'type':'hidden',
         'name': 'email_alert[email_notification_filers_attributes][][filer_id]',
         'value': filer.id}); */
    li_item.appendChild(hdn)
    list.appendChild(li_item)
    jQuery('#li_none').css('display', 'none')
    jQuery('#lnk_remove_all').css('display', 'inline')
  },
  remove_filer_link_clicked: function (e) {
    var targ
    if (!e) var e = window.event
    if (e.target) targ = e.target
    else if (e.srcElement) targ = e.srcElement
    EmailAlertDialog.remove_filer_from_list(targ.filer.id)
  },
  remove_filer_from_list: function (filer_id) {
    var list = jQuery('#selected_portfolios')[0]
    var item = jQuery('#item_' + filer_id)[0]
    item.style.display = 'none'
    list.removeChild(item)
    if (list.getElementsByTagName('li').length <= 1) {
      jQuery('#lnk_remove_all').css('display', 'none')
      jQuery('#li_none').css('display', 'inline')
    }
  },
  remove_all_filers: function (e) {
    var list = jQuery('#selected_portfolios')[0]
    var items = list.getElementsByTagName('li')
    for (var i = 0; i < items.length; i++) {
      if (!items[i].filer || items[i].style.display == 'none') continue
      id = items[i].filer.id
      var item = jQuery('#item_' + id)[0]
      item.style.display = 'none'
      list.removeChild(item)
      i--
    }
    jQuery('#lnk_remove_all').css('display', 'none')
    jQuery('#li_none').css('display', 'inline')
  },

  setup_alert_dialog: function () {
    // Define various event handlers for Dialog
    /* var handleSubmit = function() {
         if (this.submit())
         whalewisdom.Utilities.show_wait_dialog("Saving","Saving Email Alert...");
         };
         var handleCancel = function() {
         this.cancel();
         };
         var handleSuccess = function(o) {
         whalewisdom.Utilities.wait_dialog.hide();
         var response = o.responseText;
         whalewisdom.Utilities.show_alert('',"Email Alert has been saved.");
         EmailAlertDialog.alert_dialog.hide();
         if (jQuery('#alerts_table').length>0){
         EmailAlert.results_table.getDataSource().sendRequest('',
         {success: EmailAlert.results_table.onDataReturnInitializeTable,scope: EmailAlert.results_table});
         }
         };
         var handleFailure = function(o) {
         whalewisdom.Utilities.wait_dialog.hide();
         whalewisdom.Utilities.show_alert("Error saving alert",o.responseText);
         };     */
    /* EmailAlertDialog.individual_filer_module=new YAHOO.widget.Module("div_individual_filers",{visible:true});
         EmailAlertDialog.select_forms_module=new YAHOO.widget.Module("select_forms",{visible:true});
         EmailAlertDialog.industry_module=new YAHOO.widget.Module("div_industry",{visible:true});   */
    // Remove progressively enhanced content class, just before creating the module
    // YAHOO.util.Dom.removeClass("dlg_alert", "yui-pe-content");

    // Instantiate the Dialog
    /* EmailAlertDialog.alert_dialog = new YAHOO.widget.Dialog("dlg_alert",
         {width : "50em",
         height:"15em",
         fixedcenter : true,
         visible : false,
         modal:true,
         //x:300,y:50,
         hideaftersubmit:false,
         effect:{effect:YAHOO.widget.ContainerEffect.FADE,duration:0.15},
         constraintoviewport : true,
         buttons : [ {text:"Save Changes", handler:handleSubmit, isDefault:true},
         {text:"Cancel", handler:handleCancel} ]
         });   */

    // Validate the entries in the form to require that both first and last name are entered
    EmailAlertDialog.validate = function () {
      var valid = true
      var frm = jQuery('#frm_email_alert')
      var rdo = jQuery('input[name="email_alert[rdo_filer]"]:checked', frm).val()
      // if email_alert[rdo_filer] is 1 then require a value for email_alert[tag_id]
      if (rdo == '1') {
        if (jQuery('#select_predefined').val() == '') {
          whalewisdom.Utilities.show_alert('Incomplete Information',
            'Step 2 is not complete. Please choose a pre-defined group, industry or one or more individual filers')
          return false
        }
      } else if (rdo == '2') {
        if (jQuery('#hdn_industry').val() == '') {
          whalewisdom.Utilities.show_alert('Incomplete Information',
            'Step 2 is not complete. Please choose a pre-defined group, industry or one or more individual filers')
          return false
        }
      }
      // if email_alert[rdo_filer] is 2 then require at least one
      // email_alert[email_notification_filers_attributes][][filer_id] be present
      else if (rdo == '3') {
        var f = frm[0]
        var inp = f['email_alert[email_notification_filers_attributes][][filer_id]']
        if (!inp) { inp = data['email_alert[email_notification_filers_attributes][][filer_id]'] }
        if (!inp || (inp.value && inp.value == '') || (inp.length && inp.length == 0)) {
          whalewisdom.Utilities.show_alert('Incomplete Information',
            'Step 2 is not complete. Please choose a pre-defined group, industry or one or more individual filers')
          return false
        }
      } else {
        whalewisdom.Utilities.show_alert('Incomplete Information', 'Step 2 is not complete. Please choose a pre-defined group, industry or one or more individual filers')
        return false
      }
      // if email_alert[form_type]="individual" then require
      // at least one email_alert[email_notification_filing_types_attributes][][sec_filing_type_id] be checked
      rdo = jQuery('input[name="email_alert[form_type]"]:checked', frm).val()
      if (rdo == 'all') {

      } else if (rdo == 'individual') {
        if (jQuery('#filing_types').val().length == 0) {
          whalewisdom.Utilities.show_alert('Incomplete Information',
            'Step 3 is not complete')
          return false
        }
      } else {
        whalewisdom.Utilities.show_alert('Incomplete Information',
          'Step 3 is not complete')
        return false
      }
      // require  email_alert[delivery_type_id]  e either 1 or 2
      rdo = jQuery('input[name="email_alert[delivery_type_id]"]:checked', frm).val()
      if (rdo != '1' && rdo != '2') {
        whalewisdom.Utilities.show_alert('Incomplete Information',
          'Email delivery frequency has not been answered')
        return false
      }
      // require value in email_alert[subject_line]
      /*    if (jQuery('#txt_email_subject_line').val() == "") {
                whalewisdom.Utilities.show_alert("Incomplete Information",
                    "Email Subject line must be filled in");
                return false;
            } */

      if (jQuery('#txt_alert_name').val() == '') {
        whalewisdom.Utilities.show_alert('Incomplete Information',
          'Step 1: Alert name must be filled in')
        return false
      }
      return valid
    }

    // Wire up the success and failure handlers
    /* EmailAlertDialog.alert_dialog.callback = {success: handleSuccess,
         failure: handleFailure};

         // Render the Dialog
         EmailAlertDialog.alert_dialog.render();
         if (jQuery('#dlg_hider2').length>0) jQuery('#dlg_hider2').css('display',"block");
         */
    jQuery('#dlg_alert').modal({ show: false, backdrop: 'static' })
    jQuery('#cmd-save-email-alert').click(function () {
      // validate first
      if (EmailAlertDialog.validate()) {
        whalewisdom.Utilities.show_wait_dialog('Saving', 'Saving Email Alert...')
        var token = $('meta[name=csrf-token]').attr('content');
        jQuery.ajax({
          url: '/email_alert/update',
          type: 'POST',
          headers: {
           // 'Content-Type': 'application/json',
            'X-CSRF-Token': token
          },
          dataType: 'text',
          // dataType: 'json',
          data: jQuery('#frm_email_alert').serialize(),
          success: function (results) {
            if (jQuery('#alerts_table').length > 0) {
              /*   EmailAlert.results_table.getDataSource().sendRequest('',
                             {success: EmailAlert.results_table.onDataReturnInitializeTable,scope: EmailAlert.results_table});  */
              EmailAlert.setup_table()
            }
            jQuery('#cmd-save-email-alert').removeClass('disabled')
            jQuery('#cmd-save-email-alert').html('Save changes')
            jQuery('#dlg_alert').modal('hide')
            whalewisdom.Utilities.wait_dialog.hide()
            whalewisdom.Utilities.show_alert('', 'Email Alert has been saved.')
          },
          error: function (d) {
            whalewisdom.Utilities.wait_dialog.hide()

            whalewisdom.Utilities.show_alert('Error saving alert', d.responseText)
            jQuery('#cmd-save-email-alert').removeClass('disabled')
            jQuery('#cmd-save-email-alert').html('Save changes')
            jQuery('#dlg_alert').show()
          }
        })
      }
    })
  },
  on_radio_filer_change: function (e) {
    if (jQuery('#rdo_predefined')[0].checked) {
      jQuery('#txt_filer').val('')
      jQuery('#hdn_industry').val('')
      jQuery('#txt_filer').attr('disabled', true)
      jQuery('#select_predefined').attr('disabled', false)
      jQuery('#span_industry_selection').html('')
      jQuery('#select_predefined').removeClass('disabled_panel')
      jQuery('#txt_filer').addClass('disabled_panel')
      jQuery('#div_industry').addClass('disabled_panel')
      jQuery('#portfolio_container').addClass('disabled_panel')
      jQuery('#div_individual_filers').addClass('disabled_panel')
      jQuery('#div_individual_filers').removeClass('enabled_panel')
      jQuery('#portfolio_container').removeClass('enabled_panel')
      // EmailAlertDialog.individual_filer_module.hide();
      jQuery('#div_individual_filers').hide()
      jQuery('#div_industry').hide()
      // EmailAlertDialog.industry_module.hide();
    } else if (jQuery('#rdo_industry')[0].checked) {
      jQuery('#txt_filer').val('')
      jQuery('#txt_filer').attr('disabled', true)
      jQuery('#txt_filer').addClass('disabled_panel')
      jQuery('#div_industry').removeClass('disabled_panel')
      jQuery('#portfolio_container').addClass('disabled_panel')
      jQuery('#div_individual_filers').addClass('disabled_panel')
      jQuery('#select_predefined').addClass('disabled_panel')
      jQuery('#div_industry').addClass('disabled_panel')
      jQuery('#div_individual_filers').addClass('enabled_panel')
      jQuery('#portfolio_container').addClass('enabled_panel')
      jQuery('#div_industry').show()
      // EmailAlertDialog.industry_module.show();
      if (jQuery('#hdn_industry').val() == '') { jQuery('#industry_dialog').modal('show') }
      // EmailAlertDialog.industry_dialog.show();
      // EmailAlertDialog.individual_filer_module.hide();
      jQuery('#div_individual_filers').hide()
    } else {
      jQuery('#txt_filer').attr('disabled', false)
      jQuery('#hdn_industry').val('')
      jQuery('#select_predefined').attr('disabled', true)
      jQuery('#span_industry_selection').html('')
      jQuery('#select_predefined').addClass('disabled_panel')
      jQuery('#div_industry').addClass('disabled_panel')
      jQuery('#txt_filer').removeClass('disabled_panel')
      jQuery('#portfolio_container').removeClass('disabled_panel')
      jQuery('#div_individual_filers').removeClass('disabled_panel')
      jQuery('#div_individual_filers').addClass('enabled_panel')
      jQuery('#portfolio_container').addClass('enabled_panel')
      jQuery('#div_individual_filers').show()
      // EmailAlertDialog.individual_filer_module.show();
      jQuery('#div_industry').hide()
      // EmailAlertDialog.industry_module.hide();
    }
  },
  on_radio_form_types_change: function (e) {
    // var elements=jQuery('.form_type_checkbox');
    var checked = jQuery('input[name=email_alert\\[form_type\\]]:checked').val()
    if (checked === 'all') {
      jQuery('#select_forms_list').addClass('disabled_panel')
      jQuery('#select_forms_list').removeClass('enabled_panel')
      jQuery('#select_forms').hide()
      EmailAlertDialog.clear_form_types()
      // jQuery('#filing_types').multiselect("close");
      // EmailAlertDialog.select_forms_module.hide();
    } else {
      jQuery('#select_forms_list').removeClass('disabled_panel')
      jQuery('#select_forms_list').addClass('enabled_panel')
      jQuery('#select_forms').show()
      // jQuery('#filing_types').multiselect("open");
      // EmailAlertDialog.select_forms_module.show();
    }
  },
  clear_form_types: function () {
    var elements = jQuery('.form_type_checkbox')
    for (var i = 0; i < elements.length; i++) {
      elements[i].checked = false
    }
  },
  select_all_form_types: function () {
    var elements = jQuery('.form_type_checkbox')
    for (var i = 0; i < elements.length; i++) {
      elements[i].checked = true
    }
  },
  show_alert_dialog: function (e, dlg, record) {
    var child = null
    // initialize dialog fields
    jQuery('#filing_types').val('')
    jQuery('#select_predefined')[0].selectedIndex = 0
    jQuery('#rdo_all_form_types')[0].checked = true
    jQuery('#txt_email_subject_line').val(EmailAlertDialog.default_subject_line)
    jQuery('#rdo_delivery_immediate')[0].checked = true
    jQuery('#rdo_predefined')[0].checked = true
    jQuery('#email_alert_id').val('')
    jQuery('#txt_alert_name').val('Email Alert')
    jQuery('#hdn_industry').val('')
    jQuery('#span_industry_selection').html('')
    EmailAlertDialog.remove_all_filers(null)
    EmailAlertDialog.clear_form_types()
    jQuery('#tab1-anchor').tab('show')
    //   EmailAlertDialog.tabview.set('activeIndex',0);
    // EmailAlertDialog.advanced_options_module.hide();
    if (record) {
      jQuery('#email_alert_id').val(record.id)
      if (record.delivery_type_id == 1) { jQuery('#rdo_delivery_immediate')[0].checked = true } else { jQuery('#rdo_delivery_daily')[0].checked = true }
      jQuery('#txt_email_subject_line').val(record.subject_line)
      jQuery('#txt_alert_name').val(record.name)
      jQuery('#hdn_industry').val(record.stock_classification_id)
      if (record.tag_id != null && record.tag_id > 0) {
        jQuery('#rdo_predefined')[0].checked = true
        // set select_predefined to correct option
        var lst = jQuery('#select_predefined')[0]
        for (var i = 0; i < lst.options.length; i++) {
          if (lst.options[i].value == record.tag_id) {
            lst.selectedIndex = i
          }
        }
      } else if (record.stock_classification_id && record.stock_classification_id > 0) {
        jQuery('#rdo_industry')[0].checked = true
        /* var child, parent, sector;
                for (var i = 0; i < EmailAlertDialog.industries.length; i++) {
                    sector = EmailAlertDialog.industries[i];
                    if (sector.id == record.stock_classification_id) {
                        child = sector;
                        break;
                    }
                    for (var j = 0; j < sector.children.length; j++) {
                        if (sector.children[j].id == record.stock_classification_id) {
                            child = sector.children[j];
                            break;
                        }
                    }
                }
                if (child && child.parent_id && child.parent_id > 0) {
                    for (var i = 0; i < EmailAlertDialog.industries.length; i++) {
                        sector = EmailAlertDialog.industries[i];
                        if (sector.id == child.parent_id) {
                            parent = sector;
                            break;
                        }
                        for (var j = 0; j < sector.children.length; j++) {
                            if (sector.children[j].id == child.parent_id) {
                                parent = sector.children[j];
                                break;
                            }
                        }
                    }
                } */
        jQuery('#span_industry_selection').html(jQuery('a[data-id="' + record.stock_classification_id + '"]').html())// parent == null ? child.name : parent.name + ":" + child.name);
      } else {
        jQuery('#rdo_individual_filer')[0].checked = true
        for (var i = 0; i < record.email_notification_filers.length; i++) {
          child = record.email_notification_filers[i]
          EmailAlertDialog.add_filer_to_list(child.filer)
        }
      }
      var all_form_types = false
      for (var i = 0; i < record.email_notification_filing_types.length; i++) {
        child = record.email_notification_filing_types[i]
        if (child.sec_filing_type_id == 0) {
          jQuery('#rdo_all_form_types').attr('checked', true)
          // jQuery('#rdo_all_form_types')[0].checked=true;
          all_form_types = true
          break
        }
      }
      if (!all_form_types) {
        jQuery('#rdo_all_form_types').attr('checked', false)
        jQuery('#rdo_individual_form_types').attr('checked', true)
        var selected = []
        for (var i = 0; i < record.email_notification_filing_types.length; i++) {
          selected.push(record.email_notification_filing_types[i].sec_filing_type_id)
        }
        jQuery('#filing_types').val(selected)
      }
      jQuery('#filing_types').multiselect('reload')
    } else if (typeof EmailRegistration !== 'undefined' && EmailRegistration.filer) {
      var radios = jQuery('input:radio[name="email_alert[form_type]"]')
      radios.filter('[value=individual]').prop('checked', true)
      // jQuery('#rdo_individual_filer')[0].checked = true;
      EmailAlertDialog.add_filer_to_list(EmailRegistration.filer)
      jQuery('#txt_alert_name').val(EmailRegistration.filer.name + ' Email Alert')
      jQuery('#rdo_all_form_types').attr('checked', false)
      // jQuery('#rdo_individual_form_types').attr('checked', true);
      radios = jQuery('input:radio[name="email_alert[rdo_filer]"]')
      radios.filter('[value=3]').prop('checked', true)
      jQuery('#filing_types').val(['9', '21', '185', '187'])
      jQuery('#filing_types').multiselect('reload')
    }
    EmailAlertDialog.on_radio_filer_change()
    EmailAlertDialog.on_radio_form_types_change()
    jQuery('#dlg_alert').modal('show')
    // EmailAlertDialog.alert_dialog.show();
  },
  toggle_advanced_settings: function (e) {
    /* if (EmailAlertDialog.advanced_options_module.cfg.config.visible.value)
         EmailAlertDialog.advanced_options_module.hide();
         else
         EmailAlertDialog.advanced_options_module.show(); */
  },
  load_dialog_from_server: function () {
    whalewisdom.Utilities.show_wait_dialog('Please wait', 'loading....')
    $('#email-alert-container').load('/email_alert/email_alert_from_server', function () {
      whalewisdom.Utilities.wait_dialog.modal('hide')
      EmailAlertDialog.setup_after_load()
      EmailAlertDialog.show_alert_dialog()
    })
  }

}
jQuery(function () {
  EmailAlertDialog.init()
})
// YAHOO.util.Event.onDOMReady(EmailAlertDialog.init, EmailAlertDialog, true);
